/**
 * Shown on working surfaces (Inventory / Website Audit) when the operator's
 * active context is "All Groups". Full tenant isolation means these surfaces
 * require a single concrete group, so we prompt instead of mixing groups.
 */
import React from "react"

import { THEME } from "../config/theme"

interface Props {
  /** What the user would see once a group is picked, e.g. "inventory audits". */
  surface: string
}

export default function DealerGroupRequiredNotice({ surface }: Props) {
  return (
    <div
      style={{
        background: THEME.colors.neutral.light.surface,
        border: `1px solid ${THEME.colors.silver}`,
        borderRadius: THEME.borderRadius.md,
        padding: "32px 24px",
        textAlign: "center",
        color: THEME.colors.neutral.light.textSecondary,
        fontSize: "14px",
        fontFamily: THEME.fonts.primary,
      }}
    >
      Select a dealer group from the top bar to view {surface}.
    </div>
  )
}
